/**
 * Shared theme-aware Tailwind classes for Yes/No/N/A chips and badges.
 * Square chip style; no hard-coded colors; used by runs/result and human review.
 */
/** Square chip shape: slight rounding, consistent padding/size (runs/result + human review). Min width matches "Yes" chip. */
export const yesNoBadgeShapeClasses =
  "rounded-md h-[28px] min-w-11 max-w-[150px] px-3 text-sm font-medium inline-flex items-center justify-center overflow-hidden truncate shrink-0"

export const yesNoBadgeColorClasses = {
  success: "bg-coval-success-surface text-coval-success-on-surface",
  danger: "bg-coval-danger-surface text-coval-danger-on-surface",
  default: "bg-surface-1 text-coval-text",
} as const

export const yesNoBadgeWarningClasses =
  "bg-coval-warning-surface text-coval-warning-on-surface"

/** Empty/placeholder state (e.g. "N/A") */
export const yesNoBadgeEmptyClasses = "bg-surface-1 text-coval-text"
